import { all, call, cancel, delay, getContext, put, select } from 'redux-saga/effects';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { getBetPosition, TGetBetPositionResult } from '../../../services/auction/getBetPosition';
import { getBetPositionParams } from './utils';
import { selectCurrentBet, selectIsAuctionEnabled } from '../../../selectors/auction';
import { selectBetPositionClientError } from '../../../selectors/betPosition';
import { selectGeoChildLocation, selectOfferCoordinatesWithFallback } from '../../../selectors/offer';
import {
  selectActivePlacingType,
  selectIsPromotionPackageSelected,
  selectServiceIds,
} from '../../../selectors/publishTerms';
import { IAppState } from '../../../../AppModulesWrapper';
import { loadBetPositionFail, loadBetPositionStart, loadBetPositionSuccess } from '../../../actions/betPosition';
import { selectDynamicPricingData } from '../../../selectors/dynamicPricing';
import { selectConfigValue } from '../../../selectors/config';
import { selectPackages } from '../../../reducers/v2/publicationPackages/selectors';

export function* loadBetPosition() {
  const httpApi: IHttpApi = yield getContext('httpApi');
  const logger: ILogger = yield getContext('logger');

  const state: IAppState = yield select();

  const serviceIds = selectServiceIds(state);
  const clientError = selectBetPositionClientError(state);
  const childLocation = selectGeoChildLocation(state);
  const coordinates = selectOfferCoordinatesWithFallback(state);
  const packages = selectPackages(state);
  const currentBet = selectCurrentBet(state);
  const isAuctionEnabled = selectIsAuctionEnabled(state);
  const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);
  const extraData = selectDynamicPricingData(state);
  const activePlacingType = selectActivePlacingType(state);
  /**
   * @todo Удалить строку с RS
   * @description Данный функционал появился в задаче CD-166175, будет удалён в задаче CD-166972
   */
  const diffPricesPackageEnabled = selectConfigValue('diffPricesPackageEnabled', state);

  const { offer } = state.servicePickerWidget;

  if (clientError) {
    yield cancel();
  }

  const parameters = getBetPositionParams({
    packages,
    offer,
    serviceIds,
    childLocation,
    coordinates,
    currentBet,
    isAuctionEnabled,
    isPromotionPackageSelected,
    extraData,
    activePlacingType,
    /**
     * @todo Удалить строку с RS
     * @description Данный функционал появился в задаче CD-166174, будет удалён в задаче CD-166304
     */
    diffPricesPackageEnabled,
  });

  yield put(loadBetPositionStart());

  const [response]: [TGetBetPositionResult] = yield all([
    call(getBetPosition, {
      httpApi,
      logger,
      parameters,
    }),
    // При быстром ответе сервера лоадер появляется на долю секунд в компоненте позиции, из-за чего происходит мерцание.
    // Для хорошего UX ограничиваем минимально возможное выполнение запроса
    delay(1000),
  ]);

  if (response.success) {
    yield put(loadBetPositionSuccess(response.payload));
  } else {
    yield put(loadBetPositionFail());
  }
}
